module.exports = __webpack_public_path__ + "static/media/img_proof_enrollment.1bb29a57.svg";